import React from "react";
import "@gromia/components/theme/globals.css";
import { withProviders } from "@gromia/components/Providers";
import { Footer } from "@gromia/components/ui/Footer";
import { Header } from "@gromia/components/ui/Header";
import { Scripts } from "@gromia/Scripts";

type Props = {
  headerAlwaysLight?: boolean;
  headerDisableSticky?: boolean;
  footerDisabled?: boolean;
  marketingLandingPage?: boolean;
  headerDisablePhone?: boolean;
  headerEnableCtaButton?: boolean;
  children: NonNullable<React.ReactNode>;
};

export const Layout: React.FunctionComponent<Props> = withProviders(
  function LayoutPresentational(props: Props) {
    return (
      <React.Fragment>
        <Header
          alwaysLight={props.headerAlwaysLight}
          disableSticky={props.headerDisableSticky}
          disableLinks={props.marketingLandingPage}
          disablePhone={props.headerDisablePhone}
        />
        <div style={{ marginTop: !props.headerAlwaysLight ? -74 : 0 }} />
        {props.children}
        {props.footerDisabled
          ? null
          : <Footer disableLinks={props.marketingLandingPage} />}
        <Scripts />
      </React.Fragment>
    );
  },
);
